<template>
  <div class="rate">
    <div
      class="rate-item"
      v-for="(v, i) in list"
      :key="i"
    >
      <img
        class="rate-item__icon"
        src="@/assets/colorIcon/star-empty.svg"
      >
      <img
        :style="{
          width: `${v}em`
        }"
        class="rate-item__icon rate-item__icon--full"
        src="@/assets/colorIcon/star.svg"
      >
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  value: {
    type: [Number, String],
    required: true
  },
  count: {
    type: Number,
    default: 5
  }
})

const list = computed(() => {
  const result = []
  let value = Number(props.value)
  for (let i = 0; i < props.count; i++) {
    if (value >= 1) {
      result.push(1)
      value -= 1
    } else if (value > 0) {
      result.push(value)
      value = 0
    } else {
      result.push(0)
    }
  }
  return result
})
</script>

<style lang="less" scoped>
.rate {
  display: flex;

  &-item {
    position: relative;
    width: 1em;
    height: 1em;

    &__icon {
      display: block;
      width: 100%;
      height: 100%;

      &--full {
        position: absolute;
        top: 0;
        left: 0;
        object-position: left;
        object-fit: cover;
      }
    }
  }
}
</style>
